import { createContext, useContext } from 'react';
import type { ViewDensity } from '@/utils/sessionSectionPrefs';

/**
 * Densidade da interface (Conforto ↔ Compacto), provida pelo Shell — precisa
 * viver acima das páginas porque o modo Compacto também recolhe a sidebar.
 * A preferência é por usuário (loadViewDensity/saveViewDensity); o toggle
 * visível é o `DensityToggle` (ficha do paciente).
 */
interface DensityContextValue {
  density: ViewDensity;
  setDensity: (d: ViewDensity) => void;
}

export const DensityContext = createContext<DensityContextValue>({
  density: 'conforto',
  setDensity: () => {},
});

export const useDensity = () => useContext(DensityContext);
